export const API_ENDPOINT_V1 = process.env.REACT_APP_API_V1;
export const EMBED_CODE = process.env.REACT_APP_EMBED_CODE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
